<footer class="footer">
  <div class="footer__container">
    <div class="footer__widget-wrapper">
      <div class="footer__widget">
        <div class="mb-6">
          <p class="editorial-eyebrow">{{ data?.columnLeftTitle }}</p>
          <div class="mt-3 h-px w-12 bg-gold-900/40"></div>
        </div>
        <div class="footer__widget-body">
          <div class="footer__widget-text">
            <div class="grid grid-flow-col pl-3 md:pl-0 justify-start gap-x-4">
              @for (socialMediaItem of data?.socialMediaItems; track socialMediaItem) {
                <a
                  class="inline-flex items-center justify-center min-w-[44px] min-h-[44px]"
                  [href]="socialMediaItem.fields.url"
                  [attr.aria-label]="socialMediaItem.fields.ariaLabel"
                  >
                  <fa-icon [icon]="getIcon(socialMediaItem?.fields?.icon.fields.icon, socialMediaItem?.fields?.icon?.fields?.iconLibrary)"></fa-icon
                  ></a>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="footer__widget">
          <div class="mb-6">
            <p class="editorial-eyebrow">{{ data?.columnRightTitle }}</p>
            <div class="mt-3 h-px w-12 bg-gold-900/40"></div>
          </div>
          <div class="footer__widget-body">
            <!--
              Vorher leere Divs ohne Namen: für Screenreader nichts, visuell drei kaum
              unterscheidbare rote Flaggen. Der Name kommt aus Intl, nicht aus einer Liste,
              die jemand pflegen müsste.
            -->
            <ul class="footer__widget-flags">
              @for (language of data?.languageIcons; track language) {
                <li class="footer__widget-flag">
                  <span class="fi fi-{{ language }}" aria-hidden="true"></span>
                  <span class="footer__widget-flag-label">{{ regionLabel(language) }}</span>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
      <hr class="footer__divider" />
      <!--
        Ruhige Reihe statt Autoplay-Karussell: die Mitgliedschaften sind die einzigen
        belegbaren Zertifikate und sollen alle gleichzeitig sichtbar sein. Das Karussell
        zeigte sie einzeln, lief ohne Pausenknopf und saß in einem hellgrauen Kasten,
        der im Cremegrund als Fremdkörper stand.
      -->
      <div class="footer__certificates">
        <ul class="footer__badges">
          @for (certificate of data?.badges; track certificate) {
            <li class="footer__badge">
              <img
                width="640"
                height="360"
                loading="lazy"
                [alt]="certificate?.fields?.description"
                [src]="certificate?.fields?.file?.url"
                />
            </li>
          }
        </ul>
      </div>

      <div class="footer__text">
        <div class="footer__widget">
          <div class="footer__widget-body">
            <ul class="footer__widget-menu">
              @for (link of data?.navigation; track link) {
                <li class="footer__widget-list-item">
                  <a
                    class="inline-flex items-center min-h-[44px]"
                    [href]="resolveLinkUrl(link.fields.url)"
                    [attr.target]="getLinkTarget(link.fields.url)"
                    [attr.rel]="getLinkRel(link.fields.url)"
                    >
                    {{ link.fields.label }}
                  </a>
                </li>
              }
              @if (!hasCancellationLink()) {
                <li class="footer__widget-list-item">
                  <a
                    class="inline-flex items-center min-h-[44px]"
                    [href]="cancellationUrl"
                    >
                    {{ cancellationLabel }}
                  </a>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
      <div class="local-scroll">
        <button
          type="button"
          (click)="scrollToTop()"
          class="btn-bare footer__link-to-top"
          aria-label="Zurück zum Seitenanfang"
        >
          <fa-icon icon="caret-up" aria-hidden="true"></fa-icon>
        </button>
      </div>
    </div>
  </footer>
